import React from "react";
import OrderDTO from "@/dto/order/OrderDTO";
import OrderTag from "@/enum/OrderTag";
import ShopDTO from "@/dto/shop/ShopDTO";
import OrderTagWrap from "../OrderTagWrap";
import { Popover, Tooltip } from "antd";
import HkConsolidate from "../../PddConsolidate/HkConsolidate";
import XiZangConsolidate from "../../PddConsolidate/XiZangConsolidate";
import ShopType from "@/enum/ShopType";
import XinJiangConsolidate from "../../PddConsolidate/XinJiangConsolidate";

const Consolidate: React.FC<{ orderTag: OrderTag }> = React.memo(({ orderTag }) => (
    <Tooltip title="收件人地址及电话均为集运仓地址及联系电话，若您需要查看消费者信息，请您前往拼多多商家后台进行查看。">
        <OrderTagWrap className="order-icon icon-unimportant" orderTag={orderTag} style={{ height: "auto" }} />
    </Tooltip>
));

/**
 * 拼多多平台标签组件
 * 包含所有拼多多相关的标签逻辑
 */
export default function usePddTagIcons(order: OrderDTO, orderTagSet: Set<OrderTag>, shop: ShopDTO) {
    const icons = [];

    if (orderTagSet.has(OrderTag.PDD_SHIP_BY_SF)) {
        icons.push(
            <OrderTagWrap
                className="order-icon icon-important"
                key={OrderTag.PDD_SHIP_BY_SF}
                orderTag={OrderTag.PDD_SHIP_BY_SF}
            />,
        );
    }

    if (orderTagSet.has(OrderTag.PDD_DESIGNATED_PACKAGE_MATERIAL)) {
        icons.push(
            <OrderTagWrap
                className="order-icon icon-unimportant"
                key={OrderTag.PDD_DESIGNATED_PACKAGE_MATERIAL}
                orderTag={OrderTag.PDD_DESIGNATED_PACKAGE_MATERIAL}
            />,
        );
    }

    if (orderTagSet.has(OrderTag.PDD_DELIVERY_ONE_DAY)) {
        icons.push(
            <OrderTagWrap
                className="order-icon icon-unimportant"
                key={OrderTag.PDD_DELIVERY_ONE_DAY}
                orderTag={OrderTag.PDD_DELIVERY_ONE_DAY}
            />,
        );
    }

    if (orderTagSet.has(OrderTag.PDD_NO_TRACE_DELIVERY)) {
        icons.push(
            <OrderTagWrap
                className="order-icon icon-unimportant"
                key={OrderTag.PDD_NO_TRACE_DELIVERY}
                orderTag={OrderTag.PDD_NO_TRACE_DELIVERY}
            />,
        );
    }

    if (orderTagSet.has(OrderTag.PDD_COMMUNITY_GROUP)) {
        icons.push(
            <OrderTagWrap
                className="order-icon icon-unimportant"
                key={OrderTag.PDD_COMMUNITY_GROUP}
                orderTag={OrderTag.PDD_COMMUNITY_GROUP}
            />,
        );
    }

    if (orderTagSet.has(OrderTag.PDD_HK_CONSOLIDATE)) {
        icons.push(
            <Popover
                content={<HkConsolidate orderOriginalId={order.originalId} />}
                key={OrderTag.PDD_HK_CONSOLIDATE}
                placement="left"
            >
                <OrderTagWrap className="order-icon icon-unimportant" orderTag={OrderTag.PDD_HK_CONSOLIDATE} />
            </Popover>,
        );
    }

    if (orderTagSet.has(OrderTag.PDD_MACAO_CONSOLIDATE)) {
        icons.push(
            <Popover
                content={<HkConsolidate orderOriginalId={order.originalId} />} // 与香港集运使用一样的提示
                key={OrderTag.PDD_MACAO_CONSOLIDATE}
                placement="left"
            >
                <OrderTagWrap className="order-icon icon-unimportant" orderTag={OrderTag.PDD_MACAO_CONSOLIDATE} />
            </Popover>,
        );
    }

    if (orderTagSet.has(OrderTag.PDD_KAZAKHSTAN_CONSOLIDATE)) {
        icons.push(
            <Consolidate key={OrderTag.PDD_KAZAKHSTAN_CONSOLIDATE} orderTag={OrderTag.PDD_KAZAKHSTAN_CONSOLIDATE} />,
        );
    }

    if (orderTagSet.has(OrderTag.PDD_JAPAN_CONSOLIDATE)) {
        icons.push(<Consolidate key={OrderTag.PDD_JAPAN_CONSOLIDATE} orderTag={OrderTag.PDD_JAPAN_CONSOLIDATE} />);
    }

    if (orderTagSet.has(OrderTag.PDD_TAIWAN_CONSOLIDATE)) {
        icons.push(<Consolidate key={OrderTag.PDD_TAIWAN_CONSOLIDATE} orderTag={OrderTag.PDD_TAIWAN_CONSOLIDATE} />);
    }

    if (orderTagSet.has(OrderTag.PDD_KOREA_CONSOLIDATE)) {
        icons.push(<Consolidate key={OrderTag.PDD_KOREA_CONSOLIDATE} orderTag={OrderTag.PDD_KOREA_CONSOLIDATE} />);
    }

    if (orderTagSet.has(OrderTag.PDD_SINGAPORE_CONSOLIDATE)) {
        icons.push(
            <Consolidate key={OrderTag.PDD_SINGAPORE_CONSOLIDATE} orderTag={OrderTag.PDD_SINGAPORE_CONSOLIDATE} />,
        );
    }

    if (orderTagSet.has(OrderTag.PDD_MALAYSIA_CONSOLIDATE)) {
        icons.push(
            <Consolidate key={OrderTag.PDD_MALAYSIA_CONSOLIDATE} orderTag={OrderTag.PDD_MALAYSIA_CONSOLIDATE} />,
        );
    }

    if (orderTagSet.has(OrderTag.PDD_THAILAND_CONSOLIDATE)) {
        icons.push(
            <Consolidate key={OrderTag.PDD_THAILAND_CONSOLIDATE} orderTag={OrderTag.PDD_THAILAND_CONSOLIDATE} />,
        );
    }

    if (orderTagSet.has(OrderTag.PDD_VIETNAM_CONSOLIDATE)) {
        icons.push(<Consolidate key={OrderTag.PDD_VIETNAM_CONSOLIDATE} orderTag={OrderTag.PDD_VIETNAM_CONSOLIDATE} />);
    }

    if (orderTagSet.has(OrderTag.PDD_KYRGYZSTAN_CONSOLIDATE)) {
        icons.push(
            <Consolidate key={OrderTag.PDD_KYRGYZSTAN_CONSOLIDATE} orderTag={OrderTag.PDD_KYRGYZSTAN_CONSOLIDATE} />,
        );
    }

    if (orderTagSet.has(OrderTag.PDD_UZBEKISTAN_CONSOLIDATE)) {
        icons.push(
            <Consolidate key={OrderTag.PDD_UZBEKISTAN_CONSOLIDATE} orderTag={OrderTag.PDD_UZBEKISTAN_CONSOLIDATE} />,
        );
    }

    if (orderTagSet.has(OrderTag.PDD_GANSU_CONSOLIDATE)) {
        icons.push(<Consolidate key={OrderTag.PDD_GANSU_CONSOLIDATE} orderTag={OrderTag.PDD_GANSU_CONSOLIDATE} />);
    }

    if (orderTagSet.has(OrderTag.PDD_NEIMENGGU_CONSOLIDATE)) {
        icons.push(
            <Consolidate key={OrderTag.PDD_NEIMENGGU_CONSOLIDATE} orderTag={OrderTag.PDD_NEIMENGGU_CONSOLIDATE} />,
        );
    }

    if (orderTagSet.has(OrderTag.PDD_NINGXIA_CONSOLIDATE)) {
        icons.push(<Consolidate key={OrderTag.PDD_NINGXIA_CONSOLIDATE} orderTag={OrderTag.PDD_NINGXIA_CONSOLIDATE} />);
    }

    if (orderTagSet.has(OrderTag.PDD_QINGHAI_CONSOLIDATE)) {
        icons.push(<Consolidate key={OrderTag.PDD_QINGHAI_CONSOLIDATE} orderTag={OrderTag.PDD_QINGHAI_CONSOLIDATE} />);
    }

    if (orderTagSet.has(OrderTag.PDD_XINJIANG_CONSOLIDATE)) {
        icons.push(
            <Popover
                content={<XinJiangConsolidate orderOriginalId={order.originalId} />}
                key={OrderTag.PDD_XINJIANG_CONSOLIDATE}
                placement="left"
            >
                <OrderTagWrap className="order-icon icon-unimportant" orderTag={OrderTag.PDD_XINJIANG_CONSOLIDATE}>
                    新疆中转
                </OrderTagWrap>
            </Popover>,
        );
    }

    if (orderTagSet.has(OrderTag.PDD_XIZANG_CONSOLIDATE)) {
        icons.push(
            <Popover
                key={OrderTag.PDD_XIZANG_CONSOLIDATE}
                content={<XiZangConsolidate orderOriginalId={order.originalId} />}
                placement="left"
            >
                <OrderTagWrap className="order-icon icon-unimportant" orderTag={OrderTag.PDD_XIZANG_CONSOLIDATE} />
            </Popover>,
        );
    }

    if (orderTagSet.has(OrderTag.PDD_ALLERGY_REFUND)) {
        icons.push(
            <OrderTagWrap
                className="order-icon icon-unimportant"
                key={OrderTag.PDD_ALLERGY_REFUND}
                orderTag={OrderTag.PDD_ALLERGY_REFUND}
            />,
        );
    }

    if (orderTagSet.has(OrderTag.PDD_COURIER_DOOR_TO_DOOR_COLLECT)) {
        icons.push(
            <Tooltip
                key={OrderTag.PDD_COURIER_DOOR_TO_DOOR_COLLECT}
                title={
                    <span>
                        拼多多官方补贴上门揽收：拼多多官方自动联系快递上门揽件，请勿打印发货，
                        <a
                            href="https://qw15p3s8hv.feishu.cn/wiki/YFLHwxGRJiCjHKklvEkctFA1nBe#QyjhdALI9oPL3Pxuk8xcFaQOnGy"
                            target="_blank"
                        >
                            点击可查看详细说明
                        </a>
                    </span>
                }
            >
                <OrderTagWrap
                    className="order-icon icon-important"
                    orderTag={OrderTag.PDD_COURIER_DOOR_TO_DOOR_COLLECT}
                />
            </Tooltip>,
        );
    }

    if (orderTagSet.has(OrderTag.PDD_DELIVERY_APPOINTMENT)) {
        icons.push(
            <OrderTagWrap
                className="order-icon icon-important"
                key={OrderTag.PDD_DELIVERY_APPOINTMENT}
                orderTag={OrderTag.PDD_DELIVERY_APPOINTMENT}
            />,
        );
    }

    if (orderTagSet.has(OrderTag.PDD_PROMISE_ARRIVAL)) {
        icons.push(
            <OrderTagWrap
                className="order-icon icon-important"
                key={OrderTag.PDD_PROMISE_ARRIVAL}
                orderTag={OrderTag.PDD_PROMISE_ARRIVAL}
            />,
        );
    }

    if (orderTagSet.has(OrderTag.PDD_HOME_DELIVERY)) {
        icons.push(
            <Tooltip key={OrderTag.PDD_HOME_DELIVERY} title={<div>此类订单商家需要将货品送货上门</div>}>
                <OrderTagWrap className="order-icon icon-important" orderTag={OrderTag.PDD_HOME_DELIVERY} />
            </Tooltip>,
        );
    }

    if (orderTagSet.has(OrderTag.PDD_DIRECT_MAIL_ACTIVITY)) {
        icons.push(
            <Tooltip
                key={OrderTag.PDD_DIRECT_MAIL_ACTIVITY}
                title={<span>针对该订单的运费，平台会为您补贴广告红包，具体请至拼多多商家后台订单详情页查看</span>}
            >
                <OrderTagWrap className="order-icon icon-unimportant" orderTag={OrderTag.PDD_DIRECT_MAIL_ACTIVITY} />
            </Tooltip>,
        );
    }

    if (orderTagSet.has(OrderTag.PDD_WEIPAI_SERVICE)) {
        icons.push(
            <Tooltip
                key={OrderTag.PDD_WEIPAI_SERVICE}
                title={
                    <span>该订单已签署顺丰微派服务，请与物流服务商（如顺丰）确认获取现场拆封激活拍照的核验照片</span>
                }
            >
                <OrderTagWrap className="order-icon icon-important" orderTag={OrderTag.PDD_WEIPAI_SERVICE} />
            </Tooltip>,
        );
    }

    if (orderTagSet.has(OrderTag.PDD_FULFILLMENT_BY_SHARED_WAREHOUSE)) {
        icons.push(
            <Tooltip
                key={OrderTag.PDD_FULFILLMENT_BY_SHARED_WAREHOUSE}
                title="共享仓订单（含承诺送达共享仓订单）由平台直推共享仓出库发货"
            >
                <OrderTagWrap
                    className="order-icon icon-unimportant"
                    orderTag={OrderTag.PDD_FULFILLMENT_BY_SHARED_WAREHOUSE}
                />
            </Tooltip>,
        );
    }

    return icons;
}
